module.exports = __webpack_public_path__ + "img/bbq.34f14590.svg";